// extracted by mini-css-extract-plugin
module.exports = {"container":"Fk","disabled":"Gk","bgBlack":"Hk","content":"Ik","countdown":"Jk","topCaption":"Kk","topHeading":"Lk","heading":"Mk","copy":"Nk"};